const allowed_entries = ["post", "product", "category_product", "product_brand"];
const qs = (selector, root = document) => root.querySelector(selector);
const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

const was_close_search = qs("#was-close-search");
const was_suggestions_block = qs(".was-auto-suggest");
const was_search_notif = qs(".was-search-notif");
const was_suggested_words_block = qs(".was-suggestion-words"); // The block where we will display our suggested words

let was_datas = []; // Filled in ajax
let was_words = []; // Filled in ajax
let was_keysPressed = []; // For easter egg :-)
let was_user_input = ""; // What is in the search bar
let was_nb_words_displayed = 0; // Words suggested

let results_url = "";
let was_data_promise = null;

const update_results_url = () => {
	results_url = themeVars.shop_url + "?text_search=" + was_user_input;
};

// Create link to shop
const was_link_to_shop = document.createElement("a");
was_link_to_shop.className = "was-auto-suggest__btn";
was_link_to_shop.dataset.hasProduct = false;

const was_remove_accents = (str) => {
	str = String(str);
	str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	return str;
};

const was_containing_only_numbers = (str) => /^\d+$/.test(str);

const hightLight_input = (str_to_highlight) => {
	let regex = new RegExp(was_user_input, "ig");
	let str_with_highlight;

	// Highlight user input in product title
	str_with_highlight = str_to_highlight.replace(regex, function (match) {
		return `<span class="highlight">${match}</span>`;
	});

	// Highlight user input (without accent) in product title
	if (!str_with_highlight.includes('"highlight"')) {
		let sansaccent = was_remove_accents(str_to_highlight);
		let sansaccentWithHighLight = sansaccent.replace(regex, function (match) {
			return `<span class="highlight">${match}</span>`;
		});

		if (sansaccentWithHighLight.includes('<span class="highlight">')) {
			let highlightStart = sansaccentWithHighLight.indexOf('<span class="highlight">');
			let highlightEnd = highlightStart + was_user_input.length;
			str_with_highlight = str_with_highlight.substring(0, highlightStart) + '<span class="highlight">' + str_with_highlight.substring(highlightStart, highlightEnd) + "</span>" + str_with_highlight.substring(highlightEnd, str_with_highlight.length);
		}
	}
	return str_with_highlight;
};

const init = () => {
	if (was_close_search) was_close_search.addEventListener("click", (e) => {
		e.preventDefault();
		was_search_close();
	});

	// Make "ctrl + k" open the search bar
	document.addEventListener("keydown", (evt) => {
		evt = evt || window.event;
		was_keysPressed[evt.key] = true;

		if (was_keysPressed["Meta"] && evt.key == "k") {
			if (qs(".header")?.classList.contains("search-open")) {
				was_search_close();
			} else {
				qs(".search-trigger")?.click();
			}
		}
	});

	document.addEventListener("keyup", (evt) => {
		was_keysPressed = [];
	});

	// Deactivate "enter" on the form
	const was_search_input = qs(".was-search");
	if (was_search_input?.parentNode) was_search_input.parentNode.addEventListener("submit", (e) => {
		e.preventDefault();
		location.href = results_url;
		return false;
	});

	// Listener on our search bar
	if (!was_search_input) return;

	was_search_input.addEventListener("keyup", async (input_char) => {
		// Fill the var "was_datas" containing all the results of our DB
		if (was_words.length == 0) {
			if (!was_data_promise) {
				was_data_promise = fetch(themeVars.json_file, { credentials: "same-origin" })
					.then((r) => {
						if (!r.ok) throw new Error(`Failed to load search index: ${r.status}`);
						return r.json();
					})
					.then((json) => {
						was_datas = json.entries || [];
						was_words = json.words || [];
					})
					.catch(() => {
						was_datas = [];
						was_words = [];
					});
			}
			await was_data_promise;
		}

		// Listen the current character typed
		document.onkeydown = function (evt) {
			evt = evt || window.event;

			// on escape key close search bar
			if (evt.code == "Escape") {
				was_search_close();
			}

			const selected = qs(".was-suggested-word.is-selected");
			const currentIterator = selected ? Number.parseInt(selected.dataset.it || "0", 10) : 0;

			// When typing arrow down
			if (evt.code == "ArrowDown") {
				evt.preventDefault();
				const next = qs(`.was-suggested-word[data-it="${currentIterator + 1}"]`);
				next?.dispatchEvent(new MouseEvent("mouseenter", { bubbles: false }));
			}

			// When typing arrow up
			if (evt.code == "ArrowUp") {
				evt.preventDefault();
				const prev = qs(`.was-suggested-word[data-it="${currentIterator - 1}"]`);
				prev?.dispatchEvent(new MouseEvent("mouseenter", { bubbles: false }));
			}
		};

		// On arrow down / up => do not launch search
		if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(input_char.key)) return;

		was_user_input = was_search_input.value || "";
		was_search_notif.classList.add("is-visible");
		update_results_url();

		if (was_user_input.length < 3) {
			if (typeof was_suggested_words_block != null) was_suggested_words_block.innerHTML = "";
			was_search_notif.innerHTML = "Entrez au moins 3 caractères <span class='d-none d-md-inline'>pour lancer la recherche</span>";
			was_suggestions_block?.classList.remove("is-visible");
			return;
		}

		if (qs(".was-auto-suggest__btn") === null) {
			qs(".was-suggestion-product").after(was_link_to_shop);
		}

		was_display_results();
		was_display_similars_words();

		if (was_nb_words_displayed == 0) {
			was_suggestions_block?.classList.remove("is-visible");
			was_suggestions_block?.style.setProperty("--_h", "0px");
			was_search_notif.innerHTML = "Aucun résultat pour votre recherche";
			was_search_notif.classList.add("no-results");
			was_search_notif.classList.remove("press-esc");
		} else {
			was_listenSuggestedWords();
			const was_suggest_boc_h = qs(".was-auto-suggest__inner")?.getBoundingClientRect().height ?? 0;
			qs(".searchform").classList.add("searbox-open");
			was_suggestions_block?.classList.add("is-visible");
			was_suggestions_block?.style.setProperty("--_h", was_suggest_boc_h + "px");
			was_search_notif.innerHTML = "Appuyer sur <small>ESC</small> pour fermer";
			was_search_notif.classList.add("press-esc");
			was_search_notif.classList.remove("no-results");
		}
	});
};

export const WoocommerceAutoSuggestor = { init };

function was_display_results() {
	allowed_entries.forEach((entry) => {
		let entry_in_data = entry in was_datas;
		if (!entry_in_data || typeof was_datas[entry] == "undefined") return;

		// Block where we will display our entry matching the query
		let suggestions_block = qs(`.was-suggestion-${entry}`);
		let has_results = qs(`[data-has-${entry}]`);

		if (suggestions_block == null && has_results == null) return;

		was_link_to_shop.dataset.hasProduct = true;
		let matchArray = was_findMatches(was_datas[entry], true);

		if (suggestions_block != null) {
			let html = matchArray
				.slice(0, 4)
				.map((post) => {
					let postMatchingArgs = [];

					let postName = hightLight_input(post.title);

					// Highlight user input in product SKU
					if (post.hasOwnProperty("sku")) {
						let productSKU = hightLight_input(post.sku);

						if (productSKU.includes('"highlight"')) {
							postMatchingArgs["Ref"] = productSKU;
						}
					}

					// Highlight user input in product attributes
					if (post.hasOwnProperty("attributes")) {
						for (const [taxo_name, attr] of Object.entries(post.attributes)) {
							let productAttribute = hightLight_input(attr.value);

							if (productAttribute.includes('"highlight"')) {
								postMatchingArgs[attr.label] = productAttribute;
							}
						}
					}

					// Highlight user input in product brands
					if (post.hasOwnProperty("brands")) {
						post.brands.forEach((brand) => {
							let brandName = hightLight_input(brand.title);

							if (brandName.includes('"highlight"')) {
								postMatchingArgs["Marque"] = brandName;
							}
						});
					}

					let postThumb = post.thumb;
					let postUrl = post.url;

					// Create string showing in which attribute we found a match
					let postMatchingArgs_string = "";
					let new_arg;
					let nb_space;
					for (const [key, arg] of Object.entries(postMatchingArgs)) {
						new_arg = "";

						let firstHighlightStart = arg.indexOf('<span class="highlight">');
						let firstHighlightEnd = arg.indexOf("</span>");

						// Add 3 words before
						nb_space = 1;
						for (let i = firstHighlightStart - 1; i >= 0; i--) {
							if (arg[i] == ">") break;
							if (nb_space >= 5) break;
							new_arg = arg[i].replace(/(<([^>]+)>)/gi, "") + new_arg; // Remove HTML
							if (arg[i] == " ") nb_space++;
						}

						new_arg += arg.substring(firstHighlightStart, firstHighlightEnd) + "</span>";

						// Add 3 words after
						nb_space = 1;
						for (let i = firstHighlightEnd + "</span>".length; i < arg.length; i++) {
							if (arg[i] == "<") break;
							if (nb_space >= 5) break;
							new_arg = new_arg + arg[i].replace(/(<([^>]+)>)/gi, ""); // Remove HTML
							if (arg[i] == " ") nb_space++;
						}

						// Check if we need to add [...] before and after
						let arg_words = arg.split(" ");
						let new_arg_words = new_arg.split(" ");
						if (arg_words[0] != new_arg_words[0]) new_arg = "[...]" + new_arg;
						if (arg_words[arg_words.length - 1] != new_arg_words[arg_words.length - 1]) new_arg = new_arg + "[...]";

						postMatchingArgs_string += `<div><i>${key}</i> : ${new_arg}</div>`;
					}

					return `
                        <li class="was-result-item">
                            <a href="${postUrl}">
								${postThumb ? `<img src="${postThumb}" />` : ""}
								<div class="was-result-text">
									<div class="was-result-title">${postName}</div>
									<div class="was-result-args">${postMatchingArgs_string}</div>
								</div>
							</a>
                        </li>
                    `;
				})
				.join("");

			if (html) {
				suggestions_block.parentNode.classList.remove("is-empty");
				suggestions_block.innerHTML = html;
			} else {
				suggestions_block.parentNode.classList.add("is-empty");
			}
		}

		if (has_results != null) {
			if (matchArray.length <= 1) {
				was_link_to_shop.innerHTML = "Afficher l'article correspondant";
			} else {
				was_link_to_shop.innerHTML = `Afficher les <span class="was-count-product">${matchArray.length}</span> articles`;
			}
			was_link_to_shop.href = results_url;
		}
	});
}

function was_display_similars_words() {
	let it = 0;

	// Add the current word
	let first_inputed_html = `
    <li class="was-suggested-word is-selected" data-word="${was_user_input}" data-it="${it}">
        <span>${was_user_input}</span>
    </li>
    `;

	if (typeof was_words == "undefined") return;

	// Block where we will display our similars words
	if (was_suggested_words_block == null) return;

	let was_user_input_without_dash = was_user_input.replace(/-/gi, " ");
	let matchArray;

	// If user input is only numeric (we search sku, so global search)
	if (was_containing_only_numbers(was_user_input)) {
		matchArray = was_findMatches(was_words, true);
	}
	// Else -> display only words begining by user_input
	else {
		matchArray = was_findMatches(was_words, false);
	}

	let html = matchArray
		.map((word) => {
			if (it > 10) return;

			// If the word contain a space
			if (word.indexOf(" ") >= 0) return "";

			// If the word is the same that the user input (injected automatically)
			if (word.toLowerCase() == was_user_input.toLowerCase()) return "";

			it++;

			// Display similar words without "-" (example, if you type "t shirt" & "T-Shirt" => It display the word "T Shirt")
			let regex = new RegExp(was_user_input_without_dash, "gi");
			let word_without_dash = word.replace(/-/gi, " ");
			let word_with_highlight = word_without_dash.replace(regex, function (match) {
				return `<strong>${match}</strong>`;
			});

			return `
                <li class="was-suggested-word" data-word="${word}" data-it="${it}">
                    <span>${word_with_highlight}</span>
                </li>
            `;
		})
		.join("");

	was_suggested_words_block.innerHTML = first_inputed_html + html;
	was_nb_words_displayed = matchArray.length;
}

function was_listenSuggestedWords() {
	qsa(".was-suggested-word").forEach((el) => {
		el.addEventListener("mouseenter", () => {
			if (el.classList.contains("is-selected")) return;

			qsa(".was-suggested-word.is-selected").forEach((sel) => sel.classList.remove("is-selected"));

			was_user_input = el.dataset.word || "";

			update_results_url();
			was_display_results();

			el.classList.add("is-selected");

			const was_suggest_boc_h = qs(".was-auto-suggest__inner")?.getBoundingClientRect().height ?? 0;
			was_suggestions_block?.style.setProperty("--_h", was_suggest_boc_h + "px");
		});
	});
}

function was_has_matching_keywords(haystack, needle, global_search) {
	let haystack_without_accents = was_remove_accents(haystack);
	let needle_without_accents = was_remove_accents(needle);

	let regex;
	let regex_without_accents;

	if (global_search) {
		regex = new RegExp(needle, "gi");
		regex_without_accents = new RegExp(needle_without_accents, "gi");
	} else {
		regex = new RegExp("^" + needle);
		regex_without_accents = new RegExp("^" + needle_without_accents, "gi");
	}

	return haystack.match(regex) ||
		haystack.replace(/-/gi, " ").match(regex) ||
		haystack_without_accents.match(regex) ||
		haystack_without_accents.replace(/-/gi, " ").match(regex) ||
		haystack.match(regex_without_accents) ||
		haystack.replace(/-/gi, " ").match(regex_without_accents) ||
		haystack_without_accents.match(regex_without_accents) ||
		haystack_without_accents.replace(/-/gi, " ").match(regex_without_accents)
		? true
		: false;
}

function was_findMatches(elements, global_search) {
	return elements.filter((elt) => {
		let elt_title = typeof elt == "object" ? elt.title : elt;

		let title_match = was_has_matching_keywords(elt_title, was_user_input, global_search);

		if (title_match) {
			return true;
		}

		if (typeof elt == "object" && elt.hasOwnProperty("attributes")) {
			for (const [taxo_name, attr] of Object.entries(elt.attributes)) {
				let attribute_match = was_has_matching_keywords(attr.value, was_user_input, global_search);
				if (attribute_match) {
					return true;
				}
			}
		}

		if (typeof elt == "object" && elt.hasOwnProperty("brands")) {
			for (const brand of elt.brands) {
				let brand_match = was_has_matching_keywords(brand.title, was_user_input, global_search);
				if (brand_match) {
					return true;
				}
			}
		}

		if (typeof elt == "object" && elt.hasOwnProperty("sku")) {
			let sku_match = was_has_matching_keywords(elt.sku, was_user_input, global_search);
			if (sku_match) {
				return true;
			}
		}

		return false;
	});
}

function was_hide_auto_suggest_block() {
	was_suggestions_block?.classList.remove("is-visible");
}

function was_search_close() {
	const input = qs(".was-search");
	if (input) {
		input.value = "";
		input.blur();
	}
	qs(".header")?.classList.remove("search-open");
	qs(".searchform").classList.remove("searbox-open");
	was_suggestions_block?.classList.remove("is-visible");
	was_search_notif.classList.remove("is-visible");
}
